import React, { lazy, Suspense } from 'react';

const LazyDealerDisplayOrderForm = lazy(() => import('./DealerDisplayOrderForm'));

const DealerDisplayOrderForm = (props: React.JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyDealerDisplayOrderForm {...props} />
  </Suspense>
);

export default DealerDisplayOrderForm;
